<template>
  <UIBadge variant="light">
    {{ formattedDate }}
  </UIBadge>
</template>

<script>
import { getLocalDateFormat, MMM_d_yyyy } from "@shared/utils/dateTime";

export default {
  name: "DateBadge",
  props: {
    date: {
      type: [String, Date],
      required: true,
    },
    format: {
      type: String,
      default: MMM_d_yyyy,
    },
  },
  computed: {
    formattedDate() {
      return getLocalDateFormat(this.date, { format: MMM_d_yyyy });
    },
  },
}
</script>

<style lang="scss" scoped></style>